import notificationRequest from './notification-request'
import requestErrorHandler from './request-error-handler'

type Params = {
  status?: number
  action?: 'get' | 'mutate'
  onSuccess?: () => void
  onResourceFail?: () => void
  onServerFail?: () => void
}

/** Handle dựa trên kết quả HTTP request theo flow thông dụng */
const commonRequestHandler = ({
  status,
  action,
  onSuccess,
  onResourceFail,
  onServerFail,
}: Params) => {
  if (typeof status === 'number') notificationRequest(status, action)
  requestErrorHandler({ status, onSuccess, onResourceFail, onServerFail })
}

export default commonRequestHandler
